import type { Pattern } from "../types.js";

/**
 * REAL CONTENT — eneatipo 7. Portado de
 * `docs/canonical/Plantilla_maestra_nueve_eneatipos.docx`, Bloques A, B, D y E.
 *
 * En inglés, con el original español al lado de cada campo, igual que los
 * patrones 1, 6 y 9.
 *
 * Las marcas del canon se conservan: [PROPUESTA] es formulación del proyecto,
 * [LÍMITE] es un riesgo declarado, [FUENTE PROYECTO] viene de Vilaseca. Que
 * `shortHypothesis` sea [PROPUESTA] y no fuente externa importa: es la frase
 * que la persona lee como resultado.
 *
 */
export const PATTERN_7: Pattern = {
  id: "7",
  number: 7,
  // «el buscador de estímulo» — Vilaseca: «el entusiasta»
  workingName: "The seeker (working name)",
  // Patrón organizado alrededor de mantenerse en movimiento hacia opciones placenteras para evitar el contacto con el malestar
  shortHypothesis:
    "A pattern organised around staying in motion towards what is pleasant, " +
    "so as not to make contact with discomfort.",
  // Dispersión, dificultad para comprometerse con lo difícil, uso del humor para evitar temas dolorosos
  whatItExplains:
    "Scattering, difficulty committing to what is hard, and humour used to " +
    "steer away from painful subjects.",
  // El contenido concreto de qué considera cada persona estimulante; el origen de un interés puntual por la novedad
  whatItDoesNotExplain:
    "What any given person finds stimulating, or where a particular taste for " +
    "novelty came from.",
  // [LÍMITE] Que la persona se defina como «la divertida de siempre» y use la etiqueta para evitar cualquier conversación incómoda
  identityRisk:
    "Defining yourself as \u201cthe fun one\u201d and using the label to avoid any " +
    "uncomfortable conversation.",
  confusablePatterns: ["6", "8"],
  sourceRefs: [
    "Plantilla_maestra_nueve_eneatipos.docx, Eneatipo 7, Bloques A, B, D y E",
    "[LÍMITE] Vilaseca-céntrico: sin triangular contra una segunda fuente"
  ],
  contentVersion: "canon-nueve-1.0"
};
